export default __webpack_public_path__ + "static/media/success.ecf1b54c.svg";